var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "send-message-wrapper pt-3 pb-1",
      class: _vm.classesWrapper
    },
    [
      _c("audio", {
        ref: "audioDaVoz",
        staticClass: "send-message-audio-da-voz",
        attrs: { "aria-hidden": "true", autoplay: "" }
      }),
      _vm.estadoVisualDoOrb && !_vm.large
        ? _c("ComposerVozOrb", {
            attrs: { mode: _vm.estadoVisualDoOrb, nivel: _vm.nivelDoMicrofone }
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "send-message-aba" } }, [
        _vm.temCabecalho()
          ? _c(
              "div",
              { staticClass: "send-message-cabecalho" },
              [_vm._t("cabecalho")],
              2
            )
          : _vm._e()
      ]),
      _c(
        "div",
        {
          ref: "caixa",
          staticClass: "send-message-inner",
          class: _vm.classesCaixa,
          style: _vm.estiloDaCaixa,
          on: {
            paste: _vm.aoColar,
            dragover: function($event) {
              $event.preventDefault()
              return _vm.aoArrastarSobre($event)
            },
            dragleave: _vm.aoSairDoArraste,
            drop: function($event) {
              $event.preventDefault()
              return _vm.aoSoltar($event)
            }
          }
        },
        [
          _vm.showAttachments
            ? _c("ComposerAttachments", {
                ref: "anexos",
                attrs: {
                  arquivos: _vm.arquivos,
                  disabled: _vm.anexosDesabilitados,
                  "status-por-chave": _vm.statusUploadParaExibir,
                  "mensagem-erro-por-chave": _vm.mensagemErroPorChave
                },
                on: {
                  add: _vm.onAdicionarArquivos,
                  remove: _vm.onRemoverArquivo
                }
              })
            : _vm._e(),
          _vm.avisoDeAnexo
            ? _c(
                "output",
                {
                  staticClass: "send-message-aviso-anexo ia-texto-auxiliar",
                  attrs: { "aria-live": "polite" }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "warning",
                      size: 12,
                      color: "var(--warning-text)"
                    }
                  }),
                  _vm._v(" " + _vm._s(_vm.avisoDeAnexo) + " ")
                ],
                1
              )
            : _vm._e(),
          _vm.destinoDoAnexo
            ? _c(
                "output",
                {
                  staticClass: "send-message-aviso-anexo ia-texto-auxiliar",
                  attrs: {
                    "data-teste": "destino-do-anexo",
                    "aria-live": "polite"
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "user-2",
                      size: 12,
                      color: "var(--neutral-700)"
                    }
                  }),
                  _vm._v(" " + _vm._s(_vm.destinoDoAnexo) + " ")
                ],
                1
              )
            : _vm._e(),
          _vm.mostrarTranscricaoDeVoz
            ? _c(
                "span",
                {
                  staticClass: "send-message-aviso-anexo",
                  attrs: {
                    "data-teste": "transcricao-de-voz",
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "microphone",
                      size: 12,
                      color: "var(--neutral-700)"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.rotulosDeVozTempoReal.vocEstaFalando) +
                      ": " +
                      _vm._s(_vm.transcricaoDeVoz) +
                      " "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.propostaDeVozAguardando
            ? _c(
                "span",
                {
                  staticClass: "send-message-aviso-anexo",
                  attrs: {
                    "data-teste": "proposta-de-voz",
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "info-circle",
                      size: 12,
                      color: "var(--primary)"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.rotulosDeVozTempoReal.propostaAguardando) +
                      " "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.avisoDeVozTempoReal
            ? _c(
                "span",
                {
                  staticClass: "send-message-aviso-anexo",
                  attrs: {
                    "data-teste": "aviso-de-voz-tempo-real",
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "timer-warning",
                      size: 12,
                      color: "var(--warning-text)"
                    }
                  }),
                  _vm._v(" " + _vm._s(_vm.avisoDeVozTempoReal) + " ")
                ],
                1
              )
            : _vm._e(),
          _vm.chipDoComposer
            ? _c("ComandoChip", {
                ref: "chipDaFerramenta",
                staticClass: "send-message-ferramenta-chip",
                style: _vm.estiloDoChip,
                attrs: {
                  rotulo: _vm.chipDoComposer.rotulo,
                  selecionado: _vm.chipNaSelecao
                },
                nativeOn: {
                  mousedown: function($event) {
                    $event.preventDefault()
                    return _vm.selecionarTudoComChip($event)
                  }
                }
              })
            : _vm._e(),
          _vm.gravando && !_vm.modoDeVoz
            ? _c("ComposerDitarEspectro", {
                staticClass: "send-message-textarea",
                attrs: { nivel: _vm.nivelDoMicrofone }
              })
            : _c("input-by-type", {
                ref: "campo",
                staticClass: "send-message-textarea",
                attrs: {
                  type: "textarea",
                  value: _vm.value,
                  placeholder: _vm.placeholderEfetivo,
                  rows: "1",
                  "auto-grow": "",
                  "hide-details": "",
                  dense: "",
                  solo: "",
                  flat: ""
                },
                on: { input: _vm.onInput },
                nativeOn: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                        "Backspace",
                        "Delete",
                        "Del"
                      ])
                    ) {
                      return null
                    }
                    return _vm.aoApagar($event)
                  },
                  copy: function($event) {
                    return _vm.aoCopiarComChip($event)
                  },
                  cut: function($event) {
                    return _vm.aoRecortarComChip($event)
                  },
                  paste: function($event) {
                    return _vm.aoColarComando($event)
                  }
                }
              }),
          _c(
            "div",
            {
              staticClass: "send-message-toolbar",
              class: { "d-flex align-center az-gap-small": !_vm.estiloLimpo }
            },
            [
              _vm.temFerramentas
                ? _c("ComposerFerramentas", {
                    ref: "ferramentas",
                    staticClass: "send-message-ferramentas",
                    attrs: {
                      modulos: _vm.ferramentas,
                      comandos: _vm.comandosDoComposer,
                      "modo-comando": _vm.emModoComando,
                      filtro: _vm.filtroDeFerramentas,
                      "module-key-ativo": _vm.ferramentaAtiva
                        ? _vm.ferramentaAtiva.moduleKey
                        : "",
                      "mostra-anexo": _vm.showAttachments,
                      "rotulo-do-anexo": _vm.rotuloAnexos,
                      "anexo-indisponivel": _vm.anexosDesabilitados,
                      disabled: _vm.gravando
                    },
                    on: {
                      escolher: _vm.aoEscolherFerramenta,
                      anexar: _vm.abrirAnexos,
                      "sair-pelo-topo": _vm.focarCampo,
                      "abriu-sem-foco": _vm.focarCampo
                    }
                  })
                : _vm.showAttachments && _vm.estiloLimpo
                ? _c(
                    "button",
                    {
                      staticClass: "send-message-anexo",
                      attrs: {
                        type: "button",
                        disabled: _vm.anexosDesabilitados || _vm.gravando,
                        "aria-label": _vm.rotuloAnexos,
                        title: _vm.rotuloAnexos
                      },
                      on: { click: _vm.abrirAnexos }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "plus-line",
                          size: 16,
                          color: "var(--neutral-700)"
                        }
                      })
                    ],
                    1
                  )
                : _vm.showAttachments
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "span",
                                _vm._g(_vm._b({}, "span", attrs, false), on),
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "send-message-anexo",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.anexosDesabilitados ||
                                          _vm.gravando,
                                        "aria-label": _vm.rotuloAnexos
                                      },
                                      on: { click: _vm.abrirAnexos }
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "plus-line",
                                          size: 16,
                                          color: "var(--neutral-700)"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.rotuloAnexos))])]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "send-message-chips d-flex align-center" },
                [
                  _vm.showAgentSelect
                    ? _c("AgentSelect", {
                        ref: "agente",
                        attrs: {
                          "so-icone": _vm.estiloLimpo,
                          "motivo-da-trava": _vm.rotuloTravaConversa,
                          agentes: _vm.agentes,
                          "agente-ativo-id": _vm.agenteAtivoId,
                          disabled: _vm.agentSelectDisabled,
                          "abrir-por-fora": _vm.usarPaletteNosChips
                        },
                        on: {
                          change: _vm.onTrocarAgente,
                          "abrir-externo": _vm.abrirAgente
                        }
                      })
                    : _vm._e(),
                  !_vm.modeloOculto
                    ? _c("ComposerInlineSelect", {
                        ref: "modelo",
                        staticClass: "send-message-model-select",
                        attrs: {
                          "active-color": "var(--primary)",
                          icon: "ia-head",
                          "icon-color": "var(--primary)",
                          label: _vm.modelTriggerLabel,
                          options: _vm.modelSelectOptions,
                          disabled: _vm.modelSelectDisabled,
                          align: "left"
                        }
                      })
                    : _vm._e(),
                  _vm.escopoDeCliente
                    ? _c("EscopoSelect", {
                        ref: "escopo",
                        attrs: {
                          "so-icone": _vm.estiloLimpo,
                          clientes: _vm.clientes,
                          cliente: _vm.clienteEscopo,
                          agente: _vm.agenteAtivo,
                          disabled: _vm.escopoTravado,
                          "abrir-por-fora": _vm.usarPaletteNosChips
                        },
                        on: {
                          change: _vm.aoTrocarEscopo,
                          "abrir-externo": _vm.abrirEscopo
                        }
                      })
                    : _vm._e(),
                  _vm.mostrarSeletorDeVoz && _vm.sessaoDeVozAtiva
                    ? _c("VozSelect", {
                        attrs: {
                          "so-icone": _vm.estiloLimpo,
                          vozes: _vm.catalogoDeVozes,
                          "voz-ativa-id": _vm.vozSelecionada,
                          "amostra-tocando-id": _vm.amostraTocandoId,
                          "amostra-erro": _vm.amostraErro
                        },
                        on: {
                          change: _vm.aoTrocarVoz,
                          ouvir: _vm.aoOuvirAmostra
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.rotuloTravaConversa && !_vm.estiloLimpo
                ? _c(
                    "span",
                    {
                      staticClass:
                        "send-message-locked-hint ia-texto-micro d-flex align-center az-gap-xxsmall"
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "lock",
                          size: 12,
                          color: "var(--neutral-700)"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.rotuloTravaConversa) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "flex-grow-1" }),
              _vm.mostraThinkingToggle
                ? _c(
                    "button",
                    {
                      class: [
                        "ia-thinking-chip az-ds-label d-inline-flex align-center az-gap-xsmall px-2 pt-1 pb-1 flex-shrink-0",
                        _vm.thinkingEnabled
                          ? "ia-thinking-chip--active"
                          : "ia-thinking-chip--off"
                      ],
                      attrs: { type: "button", disabled: _vm.loading },
                      on: { click: _vm.onToggleThinking }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "mdi-brain", size: 12 }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.rotuloDoRaciocinio))])
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.gravando && !_vm.loading
                ? _c(
                    "button",
                    {
                      staticClass: "send-message-mic",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.rotulosDeVoz.ditar,
                        title: _vm.rotulosDeVoz.ditar
                      },
                      on: { click: _vm.iniciarDitar }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "microphone",
                          size: 13,
                          color: "var(--neutral-700)"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.sessaoDeVozAtiva && !_vm.gravando
                ? _c(
                    "button",
                    {
                      staticClass:
                        "send-message-ditar-acao send-message-ditar-acao--cancelar",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.rotulosDeVoz.sairDoModoDeVoz,
                        title: _vm.rotulosDeVoz.sairDoModoDeVoz
                      },
                      on: { click: _vm.sairDoModoDeVoz }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "close",
                          size: 13,
                          color: "var(--neutral-700)"
                        }
                      })
                    ],
                    1
                  )
                : _vm.gravando && _vm.modoDeVoz
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "send-message-mudo",
                        class: {
                          "send-message-mudo--ativo": _vm.microfoneMutado
                        },
                        attrs: {
                          type: "button",
                          "aria-label": _vm.rotuloMutar,
                          title: _vm.rotuloMutar,
                          "aria-pressed": _vm.mudoAriaPressed
                        },
                        on: { click: _vm.alternarMudo }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: _vm.microfoneMutado
                              ? "microphone-off"
                              : "microphone",
                            size: 13,
                            color: _vm.microfoneMutado
                              ? "var(--danger-text)"
                              : "var(--neutral-700)"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.podeParaEEnviar
                      ? _c(
                          "button",
                          {
                            staticClass: "send-message-voz-parar",
                            attrs: {
                              type: "button",
                              "data-teste": "voz-parar-e-enviar",
                              "aria-label": _vm.rotulosDeVoz.pararEEnviar,
                              title: _vm.rotulosDeVoz.pararEEnviarDica
                            },
                            on: { click: _vm.pararGravacao }
                          },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: "close",
                                size: 14,
                                color: "var(--white)"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "send-message-ditar-acao send-message-ditar-acao--cancelar",
                            attrs: {
                              type: "button",
                              "data-teste": "voz-sair",
                              "aria-label": _vm.rotulosDeVoz.sairDoModoDeVoz,
                              title: _vm.rotulosDeVoz.sairDoModoDeVoz
                            },
                            on: { click: _vm.sairDoModoDeVoz }
                          },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: "close",
                                size: 13,
                                color: "var(--neutral-700)"
                              }
                            })
                          ],
                          1
                        )
                  ]
                : _vm.gravando
                ? [
                    _c(
                      "button",
                      {
                        staticClass:
                          "send-message-ditar-acao send-message-ditar-acao--cancelar",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.rotulosDeVoz.cancelarDitado,
                          title: _vm.rotulosDeVoz.cancelarDitadoDica,
                          disabled: _vm.transcrevendo
                        },
                        on: { click: _vm.cancelarGravacaoPorEsc }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "close",
                            size: 13,
                            color: "var(--neutral-700)"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "send-message-ditar-acao send-message-ditar-acao--confirmar",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.rotulosDeVoz.concluirDitado,
                          title: _vm.rotulosDeVoz.concluirDitado,
                          disabled: _vm.transcrevendo
                        },
                        on: { click: _vm.pararGravacao }
                      },
                      [
                        _vm.transcrevendo
                          ? _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                size: "14",
                                width: "2",
                                color: "white"
                              }
                            })
                          : _c("icon-svg", {
                              attrs: {
                                name: "check-circle",
                                size: 17,
                                color: "var(--white)"
                              }
                            })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              !_vm.gravando
                ? _c(
                    "button",
                    {
                      staticClass: "send-message-enviar",
                      class: _vm.classesDoBotaoEnviar,
                      style: _vm.estiloDoPulsoDeEnvio,
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.loading && !_vm.canSend && !_vm.mostraIniciarVoz,
                        "aria-label": _vm.rotuloBotaoAcao,
                        title: _vm.rotuloBotaoAcao
                      },
                      on: { click: _vm.aoClicarEnviar }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: _vm.iconeDoBotaoEnviar,
                          size: _vm.loading ? 13 : 15,
                          color: _vm.corDoBotaoEnviar
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm.textoRodape
        ? _c(
            "div",
            {
              staticClass:
                "send-message-hint ia-texto-auxiliar d-flex align-center az-gap justify-end"
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "send-message-hint__texto az-text-secondary az-muted ia-texto-auxiliar text-right"
                },
                [_vm._v(_vm._s(_vm.textoRodape))]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }